// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e752f79a","732":"1867d225","977":"537e5872"}[chunkId] + ".chunk.js";
};